import { render } from "./ModelViewer.vue?vue&type=template&id=04e1dfeb&scoped=true&lang=html"
import script from "./ModelViewer.vue?vue&type=script&setup=true&lang=js"
export * from "./ModelViewer.vue?vue&type=script&setup=true&lang=js"

import "./ModelViewer.vue?vue&type=style&index=0&id=04e1dfeb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04e1dfeb"]])

export default __exports__